<swal #noticeSwal [swalOptions]="swalOptions"> </swal>
